import {
  PaymentsContext,
  PaymentsContextProvider,
  PaymentsV3,
} from '@powerupsclub/payments';
import {
  Authorization,
  TrelloPowerUpContext,
  TrelloPowerUpContextProvider,
} from '@powerupsclub/trello';
import { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { IframeConnector } from './components/IframeConnector';
import { Modal } from './components/Modal';
import { Polls } from './components/Polls';
import { VotersPopup } from './components/VotersPopup';
import { FeedbackRoute } from '@powerupsclub/feedback';
import { LoggerErrorBoundary } from '@powerupsclub/logger';

const PaymentWrapper = () => {
  const { trelloIframe } = useContext(TrelloPowerUpContext);
  const { refetchSubscription } = useContext(PaymentsContext);

  return (
    <PaymentsV3
      onComplete={async () => {
        await refetchSubscription({ waitForStatus: 'active' });
        await trelloIframe.set('board', 'private', 'hasSubscription', true);
        trelloIframe.closeModal();
      }}
      onDismiss={async () => {
        trelloIframe.closeModal();
      }}
    />
  );
};

const AuthWrapper = () => {
  const { isAuthorized, trelloIframe } = useContext(TrelloPowerUpContext);

  useEffect(() => {
    if (isAuthorized) {
      trelloIframe.closePopup();
    }
  }, [isAuthorized, trelloIframe]);

  return (
    <Authorization
      heading="Polls"
      headingStyle={{
        fontSize: '16px',
      }}
      imageSrc="./logo.png"
      imageStyle={{
        maxWidth: '75px',
        maxHeight: '75px',
      }}
    />
  );
};

function App() {
  return (
    <LoggerErrorBoundary powerUpKey="polls">
      <Router
        basename={process.env.NODE_ENV === 'development' ? undefined : '/polls'}
      >
        <Switch>
          <Route exact path="/iframeConnector" component={IframeConnector} />

          <TrelloPowerUpContextProvider
            appKey="8601ea45bb03e7e90ede1521a391a158"
            appName="Polls"
            powerUpKey="polls"
            localization={{
              defaultLocale: 'en',
              supportedLocales: ['en'],
              resourceUrl:
                process.env.NODE_ENV === 'development'
                  ? '/strings/{locale}.json'
                  : '/polls/strings/{locale}.json',
            }}
          >
            <PaymentsContextProvider>
              <Route exact path="/payment">
                <PaymentWrapper />
              </Route>
              <Route exact path="/authorize">
                <AuthWrapper />
              </Route>
              <Route exact path="/createPoll">
                <Modal />
              </Route>
              <Route exact path="/cardBackSection">
                <Polls />
              </Route>
              <Route exact path="/votersPopup/:pollIndex/:optionIndex">
                <VotersPopup />
              </Route>
              <FeedbackRoute />
            </PaymentsContextProvider>
          </TrelloPowerUpContextProvider>
        </Switch>
      </Router>
    </LoggerErrorBoundary>
  );
}

export default App;
